import React, { FC, useCallback, useContext, useMemo } from 'react';
import cn from 'classnames';
import { Button, Icon, Typography } from '@sravni/react-design-system';
import { Cross } from '@sravni/react-icons';
import { StepContext } from '../../../../../../creator/step.context';
import { LABELS } from '../../../../../../../../constants';
import styles from './styles.module.scss';
import { ProgressBar } from './progress.bar';

type SheetHeaderProps = React.ComponentPropsWithoutRef<'div'> & {
    title?: string;
    subTitle?: string;
    customTitle?: React.ComponentType | null;
    onClose?: () => void;
    hideCloseBtn?: boolean;
};

const { Text } = Typography;

export const SheetHeader: FC<SheetHeaderProps> = (props) => {
    const { className, hideCloseBtn, title, subTitle, customTitle: CustomTitle, onClose, ...other } = props;
    const { setFocusedField, focusedField, currentStepConfig, currentStep, stepsConfig } = useContext(StepContext);
    const focusedFieldName = useMemo(() => (focusedField ? LABELS[focusedField] : undefined), [focusedField]);

    const closeSheet: React.MouseEventHandler<HTMLButtonElement> = useCallback(
        (event) => {
            event.preventDefault();
            onClose?.();
            setFocusedField(null);
        },
        [setFocusedField, onClose],
    );

    const titleText = title ? title : focusedFieldName;

    const subTitleText = subTitle ? subTitle : currentStepConfig.title;

    return (
        <>
            {!CustomTitle && <ProgressBar currentStep={currentStep} steps={stepsConfig.length} />}
            <div className={cn(styles['sheet-header'], className)} {...other}>
                <div className={styles['sheet-header__text']}>
                    {CustomTitle ? (
                        <CustomTitle />
                    ) : (
                        <>
                            {subTitleText && (
                                <Text size={12} className={styles['header-subtitle']}>
                                    Шаг {currentStep + 1}. {subTitleText}
                                </Text>
                            )}
                            {titleText && (
                                <Text size={16} className={styles['header-title']}>
                                    {titleText}
                                </Text>
                            )}
                        </>
                    )}
                </div>
                {!hideCloseBtn && (
                    <Button variant="text" className={styles['sheet-header__close-btn']} onClick={closeSheet}>
                        <Icon size={20} className={styles['close-btn-icon']}>
                            <Cross />
                        </Icon>
                    </Button>
                )}
            </div>
        </>
    );
};
